/* Language of the page (English at the store root, French under /fr).
   - Links inside the page stay in the visitor's language: every internal link written as "/pages/about" in the page scripts is given the
     language prefix ("/fr/pages/about") when the page is French, the moment it appears and again right before it is clicked.
   - A small FR / EN switch sits in the top bar (wide screens), in the section menu (phones and tablets) and in the footer.
   Shopify hands over the languages it serves in window.WB_I18N = { lang, root, langs: [{ iso, root, name }] } (see snippets/wb-config.liquid). */
(function () {
  'use strict';
  var I = window.WB_I18N || {};
  /* a language folder is "/fr", the main language is "" ("/" or nothing must never be used as a prefix: "/" + "/products/x" is "//products/x", another website) */
  function folder(r) { r = String(r || '').replace(/\/+$/, ''); return r && r.charAt(0) !== '/' ? '/' + r : r; }
  var root = folder(I.root);
  var langs = (I.langs || []).map(function (l) { return { iso: l.iso, name: l.name, root: folder(l.root) }; });
  var here = I.lang || 'en';
  var other = null;
  for (var i = 0; i < langs.length; i++) if (langs[i].iso !== here) { other = langs[i]; break; }
  var SKIP = /^\/(assets|cdn|checkout|cart\/|apps|a\/|\.well-known|services|wpm|web-pixels)/;

  function local(href) { return typeof href === 'string' && href.charAt(0) === '/' && href.charAt(1) !== '/'; }
  function localize(href) {
    if (!root || !local(href) || SKIP.test(href)) return href;
    if (href === root || href.indexOf(root + '/') === 0 || href.indexOf(root + '?') === 0 || href.indexOf(root + '#') === 0) return href;
    return href === '/' ? root : root + href;
  }
  function fix(a) {
    if (a.hasAttribute('hreflang')) return;   /* the language switch itself points to the other language */
    var h = a.getAttribute('href');
    var n = localize(h);
    if (n !== h) a.setAttribute('href', n);
  }
  if (root) {
    var sweep = function (node) {
      if (node.nodeType !== 1) return;
      if (node.tagName === 'A') fix(node);
      var list = node.querySelectorAll ? node.querySelectorAll('a[href^="/"]') : [];
      for (var j = 0; j < list.length; j++) fix(list[j]);
    };
    new MutationObserver(function (muts) {
      for (var m = 0; m < muts.length; m++) {
        var x = muts[m];
        if (x.type === 'attributes') { if (x.target.tagName === 'A') fix(x.target); continue; }
        for (var k = 0; k < x.addedNodes.length; k++) sweep(x.addedNodes[k]);
      }
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
    document.addEventListener('click', function (e) { var a = e.target && e.target.closest && e.target.closest('a[href]'); if (a) fix(a); }, true);
    document.addEventListener('DOMContentLoaded', function () { sweep(document.documentElement); });
  }

  /* ?wb=info shows what this page sees (device, width, zoom, bar), so a screenshot from any screen tells exactly which version is served */
  if (/[?&]wb=info\b/.test(location.search)) {
    var tag = document.createElement('div');
    tag.setAttribute('style', 'position:fixed;left:8px;bottom:8px;z-index:2147483600;padding:8px 10px;border-radius:10px;background:#171717;color:#fff;font:600 12px/1.45 system-ui,sans-serif;box-shadow:0 6px 20px rgba(0,0,0,.35);pointer-events:none');
    var paint = function () {
      var pill = document.querySelector('.nav-pill'), links = pill ? pill.querySelectorAll('nav.nav-links a') : [], shown = 0;
      for (var k = 0; k < links.length; k++) if (links[k].style.display !== 'none') shown++;
      tag.innerHTML = 'device: <b>' + (window.WB_PHONE ? 'phone' : 'desktop or tablet') + '</b> · width <b>' + innerWidth + '</b> px · screen ' + screen.width + 'x' + screen.height + ' · pixel ratio ' + (window.devicePixelRatio || 1) + '<br>bar: <b>' + (window.WB_PHONE ? 'phone bar' : (shown ? shown + ' of ' + links.length + ' links + menu' : 'menu only')) + '</b> · lang ' + document.documentElement.lang;
    };
    document.addEventListener('DOMContentLoaded', function () { document.body.appendChild(tag); paint(); setInterval(paint, 700); });
  }

  /* the same page in the other language */
  function otherUrl() {
    if (!other) return '';
    var p = location.pathname;
    if (root && (p === root || p.indexOf(root + '/') === 0)) p = p.slice(root.length) || '/';
    var to = other.root || '';
    var path = to ? (p === '/' ? to : to + p) : p;
    return path + location.search + location.hash;
  }
  var NAMES = { en: 'English', fr: 'Français' };
  var name = other ? (NAMES[other.iso] || other.name || other.iso.toUpperCase()) : '';
  window.WB_LANG_URL = otherUrl;
  window.WB_LANG = other ? { code: other.iso, label: other.iso.toUpperCase(), name: name } : null;
  if (!other) return;

  var css = document.createElement('style');
  css.textContent = [
    '.wb-langbtn{flex:none;display:inline-flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:50%;border:1px solid var(--border-card,#e6dfd3);background:#fff;color:var(--text-primary,#171717);font:800 12px/1 Manrope,system-ui,sans-serif;letter-spacing:.04em;text-decoration:none;transition:border-color .15s,transform .15s}',
    '.wb-langbtn:hover{border-color:#FC6306}.wb-langbtn:active{transform:scale(.94)}.wb-langbtn:focus-visible{outline:2px solid #FC6306;outline-offset:2px}',
    /* in the bar on every screen: a little smaller than the cart button where the bar is tight */
    '.wb-navr .wb-langbtn{order:2!important}.wb-navr .wb-menu-btn{order:3!important}',
    '@media (max-width:820px){html[data-wb-device="phone"] header .nav-pill .wb-langbtn{width:clamp(28px,8vw,34px);height:clamp(28px,8vw,34px);font-size:11px;letter-spacing:.02em}}',
    /* phones keep the whole Buy label ("Buy AI Phone", "Acheter l\u2019AI Phone"): their bar has two rows, see V-NAV2 in mobile-src/wb-mobile.css */
    '.wb-menu-panel a.wb-mp-lang{justify-content:center;margin-top:8px;padding:12px;border:1.5px solid #2c2c2c;border-radius:12px;font-size:16px;font-weight:800}',
    '.wb-langlink{color:var(--wb-cream);font-size:14px;font-weight:700;text-decoration:none;border:1px solid var(--border-inverse);border-radius:999px;padding:6px 14px}.wb-langlink:hover{border-color:var(--wb-orange)}'
  ].join('');
  document.head.appendChild(css);

  function place() {
    var pill = document.querySelector('.nav-pill');
    if (pill) {
      var b = pill.querySelector('.wb-langbtn');
      var cart = pill.querySelector('.wb-cartbtn');
      var buy = pill.querySelector('a.nav-buy');
      if (!b && buy && buy.parentElement) {
        b = document.createElement('a');
        b.className = 'wb-langbtn'; b.href = otherUrl(); b.textContent = other.iso.toUpperCase();
        b.setAttribute('hreflang', other.iso); b.setAttribute('lang', other.iso); b.setAttribute('aria-label', name); b.title = name;
        buy.parentElement.insertBefore(b, buy.nextSibling);
      }
      /* the order of the bar: logo, phone, Buy, cart, language, menu */
      if (b && cart && cart.parentNode === b.parentNode && cart.nextElementSibling !== b) cart.parentNode.insertBefore(b, cart.nextSibling);
    }
    var panel = document.querySelector('.wb-menu-panel');
    if (panel && !panel.querySelector('.wb-mp-lang')) {
      var m = document.createElement('a');
      m.className = 'wb-mp-lang'; m.href = otherUrl(); m.textContent = name;
      m.setAttribute('hreflang', other.iso); m.setAttribute('lang', other.iso);
      panel.appendChild(m);
    }
  }
  /* the bar and the menu are drawn by the page scripts a moment after load; a click always goes to the current page's twin */
  var n = 0, t = setInterval(function () { place(); if (++n > 80) clearInterval(t); }, 250);
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a.wb-langbtn,a.wb-mp-lang,a.wb-langlink');
    if (a) a.setAttribute('href', otherUrl());
  }, true);
})();
